import { FontCategory } from '@quicktools/shared-components/data/fonts';

const props = {
  canonicalPath: 'text/font-generator/glitch/',
  headTitle: 'Free Glitch Text Generator',
  headDescription:
    'Use the Picsart free glitch text generator to create unique and weird glitch text effects for social media, blogs, websites, and more.',
  heading: 'Make Text a Work of Art with Glitch Text Generator',
  description:
    'Transform your text into a visual masterpiece with your favorite glitch font using the Picsart Glitch Text Generator.',
  selectedCategory: FontCategory.Glitch,
  inputPlaceholder: 'Write to see your glitchy fonts…',
  landingText: {
    imageSection: [
      {
        imgSrc: 'https://cdn140.picsart.com/91200077041077118836.webp',
        imgAlt: 'glitch text',
        imageWidth: 355,
        imageRight: false,
        title: 'What is a Glitch Text Generator?',
        children: {
          paragraph: `A glitch text generator can help you transform standard text into unique and strange <a className='link--underline' href='https://picsart.com/fonts/?style=Glitch/' target='_blank'>glitch fonts</a>, which are meant to simulate computer bugs and tech glitches that happen in software and web apps. A glitch text effect has become a popular part of modern digital media, serving as a good caption for memes, usernames in apps like Twitch or Discord, website captions, and more. A glitch font generator makes it easier than ever to transform your text into glitch text you can copy and paste into your chosen app or website, letting you create a unique aesthetic for your profile, social media channel, website, and more.`,
        },
      },
      {
        imgSrc: 'https://cdn140.picsart.com/78250090195955345646.webp',
        imgAlt: 'glitch text generator',
        imageWidth: 253,
        imageRight: true,
        title: 'Is a Zalgo Text Generator Different Than a Glitch Text Generator?',
        children: {
          paragraph:
            'A Zalgo text generator is another name for a glitch font generator. Just like with a glitch text effect, a Zalgo text generator is meant to transform fonts into odd or strange fonts that can provide an eerie or uneasy impression on viewers or readers. If you are looking for to create Zalgo text, a glitch font generator can help you achieve the same goal.',
        },
      },
      {
        imgSrc: 'https://cdn140.picsart.com/62701299633381232838.webp',
        imgAlt: 'glitch font generator',
        imageWidth: 253,
        imageRight: false,
        title: 'Where Do You Use a Glitch Text Effect?',
        children: {
          paragraph:
            'The most popular use case for a glitch text generator is for transforming text for social media posts and pages. Glitch text can help you transform your messages, post content, profile pictures, or pages into something more unique that jumps off the feed for viewers and users. You can also use a glitch text generator to match your visual aesthetic, including the themes you use for your channel or pages, your images themselves, and more.',
        },
      },
      {
        imgSrc: 'https://cdn140.picsart.com/06350059335479530960.webp',
        imgAlt: 'glitch text generator',
        imageWidth: 253,
        imageRight: true,
        title: 'Why Use the Picsart Glitch Text Generator?',
        children: {
          paragraph:
            'Picsart offers a user-friendly glitch font generator that has everything you need to create the perfect glitch text effect:',
          list: [
            'The Picsart glitch text generator is completely free to use, and no sign-up is required.',
            'No annoying advertisements or email blasts for you to deal with.',
            'A variety of glitch text effect fonts to choose from, with more being added regularly.',
            'Transform your text in the glitch text generator in seconds, with just a few clicks.',
            'Easily copy and paste glitch text into and out of any app or website without any hassle or learning curve required.',
          ],
        },
      },
    ],
    howToSection: {
      title: 'How to use the glitch text generator',
      steps: [
        {
          title: 'Add your text',
          description:
            'Choose the text you want to transform with the glitch text generator and copy and paste it into the tool.',
        },
        {
          title: 'Browse Glitch Text Effect Styles',
          description:
            'Choose from a variety of glitch text effect fonts in the glitch text generator until you find your personal favorite.',
        },
        {
          title: 'Copy and Paste Glitch Text',
          description:
            'Once you have the glitch text you want, simply copy and paste the glitch text back into the app or website you want to use it for and you are done.',
        },
      ],
      cta: 'Get Started!',
    },
    similarTools: {
      paragraph:
        'Looking for additional text tools aside from a glitch text generator? Picsart offers a suite of free text tools perfect for any need.',
    },
    moreInfo: {
      title: 'Need some more info?',
      description: 'Picsarts friendly support team will be happy to help.',
      btn: 'Get in touch',
    },
  },
};

export default props;
